import { render, staticRenderFns } from "./OpeningLead.vue?vue&type=template&id=a9f91be4&scoped=true&"
import script from "./OpeningLead.vue?vue&type=script&lang=js&"
export * from "./OpeningLead.vue?vue&type=script&lang=js&"
import style0 from "./OpeningLead.vue?vue&type=style&index=0&id=a9f91be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f91be4",
  null
  
)

export default component.exports